const baseColors = {
    transparent: 'transparent',
    inherit: 'inherit',
    brand: {
        navy: '#150E3F',
        deepLavendar: '#7E4BBC',
        orange: '#F15852',
    },
    neutrals: {
        900: '#1F1F23',
        800: '#484851',
        700: '#6C6C7A',
        750: '#5B5B67',
        600: '#A0A0AB',
        500: '#BCBCC3',
        400: '#DBDBE0',
        300: '#E7E7E9',
        200: '#F1F1F3',
        100: '#F6F6F7',
        0: '#FFFFFF',
    },
    indigos: {
        900: '#2222C3',
        800: '#391EE6',
        500: '#492FF4',
        200: '#D7D7FE',
        100: '#EBEBFE',
    },
    greens: {
        900: '#064C1D',
        800: '#095D25',
        500: '#06742B',
        200: '#B1F6BD',
        100: '#D1FFD9',
    },
    yellows: {
        800: '#704D00',
        500: '#FFBF00',
        200: '#FFE38D',
        100: '#FFF1C7',
    },
    reds: {
        900: '#860329',
        800: '#9E002D',
        500: '#BF0338',
        400: '#E70545',
        200: '#FFCCD2',
        100: '#FFE6E9',
    },
};
export const colors = {
    ...baseColors,
    text: {
        inherit: baseColors.inherit,
        onDark: baseColors.neutrals[0],
        default: baseColors.neutrals[900],
        secondary: baseColors.neutrals[700],
        secondaryOnGray: baseColors.neutrals[750],
        primary: baseColors.indigos[500],
        primaryOnDark: baseColors.indigos[100],
        error: baseColors.reds[500],
        errorOnDark: baseColors.reds[100],
        warning: baseColors.yellows[800],
        success: baseColors.greens[500],
        activationOnDark: baseColors.greens[100],
    },
    textLoading: {
        inherit: baseColors.inherit,
        onDark: baseColors.neutrals[0],
        default: baseColors.neutrals[100],
        secondary: baseColors.neutrals[100],
        secondaryOnGray: baseColors.neutrals[500],
        primary: baseColors.indigos[100],
        primaryOnDark: baseColors.indigos[100],
        error: baseColors.neutrals[100],
        errorOnDark: baseColors.neutrals[100],
        warning: baseColors.neutrals[100],
        success: baseColors.neutrals[100],
        activationOnDark: baseColors.greens[100],
    },
    forms: {
        label: baseColors.neutrals[900],
        placeholder: baseColors.neutrals[700],
        placeholderActive: baseColors.neutrals[600],
        placeholderOnGray: baseColors.neutrals[750],
    },
    borders: {
        none: baseColors.transparent,
        default: baseColors.neutrals[400],
        form: baseColors.neutrals[700],
        primary: baseColors.indigos[500],
        primaryActive: baseColors.indigos[900],
        error: baseColors.reds[500],
        errorActive: baseColors.reds[900],
        activationActive: baseColors.greens[900],
    },
    outlines: {
        input: baseColors.indigos[500],
        default: baseColors.brand.deepLavendar,
    },
    shadows: {
        white: baseColors.neutrals[0],
        default: baseColors.neutrals[400],
        secondary: baseColors.neutrals[900],
        primary: baseColors.indigos[500],
        success: baseColors.greens[800],
        warning: baseColors.yellows[800],
        error: baseColors.reds[900],
        primaryDestructive: baseColors.reds[500],
        activation: baseColors.greens[500],
    },
    controls: {
        inherit: baseColors.inherit,
        default: baseColors.neutrals[900],
        primary: baseColors.indigos[500],
        primaryHover: baseColors.indigos[800],
        primaryActive: baseColors.indigos[900],
        secondary: baseColors.neutrals[200],
        secondaryOnGray: baseColors.neutrals[300],
        secondaryHover: baseColors.neutrals[400],
        secondaryActive: baseColors.neutrals[500],
        secondaryAccent: baseColors.indigos[100],
        subtle: baseColors.transparent,
        subtleHover: baseColors.neutrals[400],
        subtleActive: baseColors.neutrals[500],
        destructive: baseColors.reds[500],
        destructiveHover: baseColors.reds[800],
        destructiveActive: baseColors.reds[900],
        secondaryDestructive: baseColors.reds[100],
        subtleDestructive: baseColors.transparent,
        subtleDestructiveHover: baseColors.reds[500],
        subtleDestructiveActive: baseColors.reds[800],
        white: baseColors.neutrals[0],
        activation: baseColors.greens[500],
        activationHover: baseColors.greens[800],
        activationActive: baseColors.greens[900],
        notification: baseColors.reds[400],
    },
    skeletons: {
        primary: baseColors.indigos[100],
        destructive: baseColors.reds[100],
        secondary: baseColors.neutrals[500],
        secondaryActive: baseColors.neutrals[500],
        secondaryAccent: baseColors.neutrals[500],
        secondaryDestructive: baseColors.reds[200],
        secondaryOnGray: baseColors.neutrals[500],
        subtle: baseColors.neutrals[500],
        subtleDestructive: baseColors.reds[100],
        activation: baseColors.greens[100],
    },
    backgrounds: {
        none: baseColors.transparent,
        onGray: baseColors.neutrals[0],
        default: baseColors.neutrals[100],
        secondary: baseColors.neutrals[200],
        secondaryOnGray: baseColors.neutrals[300],
        accent: baseColors.indigos[100],
        success: baseColors.greens[100],
        warning: baseColors.yellows[100],
        error: baseColors.reds[100],
        dark: baseColors.neutrals[900],
    },
};
//# sourceMappingURL=colors.js.map